execv2.actions.save = function () {
}

execv2.actions.objects = {
    // Objetos para submit
    inpAction: document.getElementById("inpAction"),
    __viewstate: document.getElementById("__VIEWSTATE"),
    inpDsMessageOtherAction: document.getElementById("inpDsMessageOtherAction"),
    inpOtherOptions: document.getElementById("inpOtherOptions"),
    // Objetos do execute actions forward
    btnForwardTask: document.getElementById("btnForwardTaskME2"),
    inpDsNameUserForwardTo: document.getElementById("inpDsNameUserForwardTo"),
    inpDsUserForwardTo: document.getElementById("inpDsUserForwardTo"),
    inpDsForwardMessage: document.getElementById("inpDsForwardMessage"),
    modalForwardTask: document.getElementById("modalForwardTask"),
    modalForwardTaskLinkCancel: document.getElementById("modalForwardTaskLinkCancel"),
    // Objetos do execute actions askopnion
    modalAskOpinion: document.getElementById("modalAskOpinion"),
    modalAskOpinionLinkCancel: document.getElementById("modalAskOpinionLinkCancel"),
    btnAskOpnion: document.getElementById("btnAskOpnionME2"),
    inpDsUserAskOpinionTo: document.getElementById("inpDsUserAskOpinionTo"),
    inpDsAskOpinionMessage: document.getElementById("inpDsAskOpinionMessage"),
    // Objetos do execute actions cancel solicitation
    btnCancel: document.getElementById("btnCancelME2"),
    inpDsCancelMessage: document.getElementById("inpDsCancelMessage"),
    modalCancel: document.getElementById("modalCancel"),
    modalCancelLinkCancel: document.getElementById("modalCancelLinkCancel"),
    // Objetos do execute actions devolver tarefa
    btnBack: document.getElementById("btnBackME2"),
    modalTakeback: document.getElementById("modalTakeback"),
    modalTakebackLinkCancel: document.getElementById("modalTakebackLinkCancel"),
    inpDefinedCodToElement: document.getElementById("inpDefinedCodToElement"),
    inpCodElementToTakeBack: document.getElementById("inpCodElementToTakeBack"),
    inpDsTakeBackMessage: document.getElementById("inpDsTakeBackMessage"),
    // Objetos do execute actions assumir tarefa
    btnAssumeTask: execv2.util.safeGetElementById("btnAssumeTask")
}

execv2.actions.submitForm = function (action, target) {
    execv2.actions.objects.inpAction.value = action;

    if (execv2.actions.objects.__viewstate !== null)
        execv2.actions.objects.__viewstate.value = "";

    var form = document.getElementById("frm");
    form.action = `${smlbpms.baseUrl}2.0/execute`;
    form.target = target;

    form.submit();
}

execv2.actions.createBSNModelByElement = (elementModal, linkCancel) => {
    if (!elementModal) return;
    const modalInstance = new BSN.Modal(elementModal, { backdrop: true, keyboard: true });
    modalInstance.show();
    linkCancel.addEventListener("click", () => { modalInstance.hide(); });
}

execv2.actions.askOpinionOpenModal = function () {
    if (!execv2.actions.objects.modalAskOpinion) return;
    execv2.actions.createBSNModelByElement(execv2.actions.objects.modalAskOpinion, execv2.actions.objects.modalAskOpinionLinkCancel);
}

execv2.actions.opinion = function () {
    if (execv2.actions.objects.inpDsUserAskOpinionTo.value == "") {
        execv2.actions.objects.modalAskOpinion.querySelector(".text-error")?.classList.remove("hide");
        return;
    }

    bsml.toggleButtonSpinner(execv2.actions.objects.btnAskOpnion);

    h.getJSON(execv2.services.urlTaskPositionOtherActions + "&u=" + execv2.objects.inpCodUserForwardTo.value,
        function (data) {
            if (data.success == null) return;

            if (!data.success) {
                execv2.actions.objects.inpDsNameUserForwardTo.value = execv2.actions.objects.inpDsUserAskOpinionTo.value;

                if (execv2.actions.objects.inpDsAskOpinionMessage.value != '')
                    execv2.actions.objects.inpDsMessageOtherAction.value = execv2.actions.objects.inpDsAskOpinionMessage.value;

                execv2.hideControllerBlock();

                execv2.actions.submitForm("ASKOPINION", "ifrmProcess");
            } else {
                bsml.alert(mlMsgUserAlreadyOwner);
            }
        }
    );
}

execv2.actions.forwardTaskOpenModal = function () {
    if (!execv2.actions.objects.modalForwardTask) return;
    execv2.actions.createBSNModelByElement(execv2.actions.objects.modalForwardTask, execv2.actions.objects.modalForwardTaskLinkCancel);
}

execv2.actions.forward = function () {
    if (execv2.actions.objects.inpDsUserForwardTo.value == "") {
        execv2.actions.objects.modalForwardTask.querySelector(".text-error")?.classList.remove("hide");
        return;
    }

    bsml.toggleButtonSpinner(execv2.actions.objects.btnForwardTask);

    h.getJSON(execv2.services.urlTaskPositionOtherActions + "&u=" + execv2.objects.inpCodUserForwardTo.value,
        function (data) {
            if (data.success == null) return;

            if (!data.success) {
                execv2.actions.objects.inpDsNameUserForwardTo.value = execv2.actions.objects.inpDsUserForwardTo.value;

                if (execv2.actions.objects.inpDsForwardMessage.value != '')
                    execv2.actions.objects.inpDsMessageOtherAction.value = execv2.actions.objects.inpDsForwardMessage.value;

                execv2.hideControllerBlock();

                execv2.actions.submitForm("FORWARD", "ifrmProcess");
            } else {
                bsml.alert(mlMsgUserAlreadyOwner);
            }
        }
    );
}

execv2.actions.cancelOpenModal = function () {
    if (!execv2.actions.objects.modalCancel) return;
    execv2.actions.createBSNModelByElement(execv2.actions.objects.modalCancel, execv2.actions.objects.modalCancelLinkCancel);
}
execv2.actions.cancelSolicitation = function (messageconfirm) {
    // Confirma se o usuário realmente deseja cancelar passando a mensagem Resources.Execute.MsgCancelWarning
    bsml.confirm(messageconfirm, function () {

        if (execv2.actions.objects.inpDsCancelMessage.value != '')
            execv2.actions.objects.inpDsMessageOtherAction.value = execv2.actions.objects.inpDsCancelMessage.value;

        execv2.hideControllerBlock();

        execv2.actions.submitForm("CANCEL", "ifrmProcess");
    });
}

execv2.actions.takeBackOpenModal = function () {
    if (!execv2.actions.objects.modalTakeback) return;
    execv2.actions.createBSNModelByElement(execv2.actions.objects.modalTakeback, execv2.actions.objects.modalTakebackLinkCancel);

    h.getJSON(execv2.services.urlTakeback,
        function (data) {
            if (data.success == null) return;
            var found = false;
            if (data.success) {
                inpCodElementToTakeBack.childNodes.forEach((childNode) => { childNode.remove() });

                data.success.forEach((obj, index) => {
                    if (data.success[index].c != document.getElementById("inpCodFlowElement").value) {
                        found = true;
                        inpCodElementToTakeBack.add(new Option(data.success[index].t, data.success[index].c));
                    }
                });

                if (!found) {
                    document.getElementById("takeback-form")?.classList.add("hide");
                    document.getElementById("takeback-empty")?.classList.remove("hide");
                }

            }
        }
    );
}


execv2.actions.takeBack = function (takebackresult) {
    bsml.toggleButtonSpinner(execv2.actions.objects.btnBack);

    execv2.actions.objects.inpDefinedCodToElement.value = execv2.actions.objects.inpCodElementToTakeBack.value;
    if (execv2.actions.objects.inpDsTakeBackMessage.value != '')
        execv2.actions.objects.inpDsMessageOtherAction.value = execv2.actions.objects.inpDsTakeBackMessage.value;

    document.getElementById("inpDsFlowResult").value = takebackresult;
    execv2.hideControllerBlock();

    execv2.actions.submitForm("UPDATE", "ifrmProcess");
}

execv2.actions.assumeTask = function () {
    bsml.confirm(mlConfirmAssumeTask, async function () {
        btnAssumeTask.classList.add("btn-spinner-active");

        const isTaskOwner = await execv2.ownership.confirm();
        let assumeTask = false;

        if (isTaskOwner)
            assumeTask = await execv2.ownership.claim();

        btnAssumeTask.classList.remove("btn-spinner-active");

        if (!assumeTask) {
            bsml.toast(mlErrorAssumeTask,
                "alert-notification-danger");
            return;
        }

        bsml.toast(mlAssumeTaskSuccess,
            "alert-notification-success");
    });
}

execv2.actions.inpOtherOptionsChange = function (event) {
    if (!this.options || !this.selectedIndex) return;

    const selectedOption = this.options[this.selectedIndex];
    const selectedValue = selectedOption.value;
    const otherActions = {
        askOpinion: execv2.actions.askOpinionOpenModal,
        forwardTask: execv2.actions.forwardTaskOpenModal,
        takeBackProcess: execv2.actions.takeBackOpenModal,
        cancelProcess: execv2.actions.cancelOpenModal,
        seeReport: () => {
            const reportLink = selectedOption.getAttribute('data-report-link')
            if (reportLink) window.open(reportLink);
        }
    }
    if (otherActions[selectedValue]) {
        otherActions[selectedValue]();
    }
    this.value = '';
}

execv2.actions.setup = function () {
    h.addEventListener(execv2.actions.objects.btnForwardTask, "click", execv2.actions.forward);
    h.addEventListener(execv2.actions.objects.btnAskOpnion, "click", execv2.actions.opinion);
    h.addEventListener(execv2.actions.objects.btnCancel, "click", function () { execv2.actions.cancelSolicitation(execv2.actions.objects.btnCancel.getAttribute("cancelconfirm")); });
    h.addEventListener(execv2.actions.objects.btnBack, "click", function () { execv2.actions.takeBack(execv2.actions.objects.btnBack.textContent); });
    h.addEventListener(execv2.actions.objects.btnAssumeTask, "click", execv2.actions.assumeTask);

    //TODO: migrar para h.addEventListener quando o bootstrap suportar adicionar evento change em campo select-one.
    execv2.actions.objects.inpOtherOptions?.addEventListener("change", execv2.actions.inpOtherOptionsChange);
}

execv2.actions.setup();